export default __webpack_public_path__ + "37026b16c7f19440a08438cb734f78bd.svg";